import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";
import course04 from "../../../course/course-04/course";
import lesson0402 from "../../../lesson/course-04/lesson-02/lesson";
import lesson0403 from "../../../lesson/course-04/lesson-03/lesson";
import lesson0409 from "../../../lesson/course-04/lesson-09/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "ccf8bcbd-deef-4ff2-8451-d44fff8952c7",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0402),
    lesson: lesson0402,
  },
  {
    id: "4e8c42cc-d7ed-471d-ae0a-6244e5821264",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0403),
    lesson: lesson0403,
  },
  {
    id: "4f4bd9a8-29d1-48ca-8f19-f0b8e8c8f392",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0409),
    lesson: lesson0409,
  },
];

export default lessonLinks;
